import { formatDateYYYYMMDD } from '../utils/date-formatting';

export const dateToday = new Date();

export const currentDateFormatted = formatDateYYYYMMDD(new Date());
